export const LTV_RATIO = 0.5;
